import { createFileRoute } from "@tanstack/react-router";
import TwoFactorVerify from "@/pages/TwoFactorVerify";

export const Route = createFileRoute("/2fa-verify")({
  head: () => ({
    meta: [
      { title: "Verificatie in twee stappen | De Hussel App" },
      { name: "description", content: "Bevestig je inlog met de verificatiecode uit je authenticator-app." },
      { property: "og:title", content: "Verificatie in twee stappen | De Hussel App" },
      { property: "og:description", content: "Bevestig je inlog met de verificatiecode uit je authenticator-app." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: TwoFactorVerify,
});
